import React from 'react'
import { getImages } from '../components/Common/const'
import MarkBrand from '../components/Common/MarkBrand'
import ScheduleAppointment from '../components/MarkCustoms/ScheduleAppointment'
const mmdList = [
    {
        image: 'mmd-feature-img-1.jpg',
        title: 'Premium Detailing',
        tabId: 'Premium-Detailing',
        content: 'Our Premium Detailing service includes deep cleaning and added protection, for a full exterior that gets everything fresh and clean. Our team will perform a thorough process of washing, waxing, sealing, polishing, decontaminating, vacuuming, shampooing, and odor removal.',
    },
    {
        image: 'mmd-feature-img-2.jpg',
        title: 'Modesta Glass Coatings',
        tabId: 'Modesta-Glass-Coatings',
        content: 'Modesta Glass Coatings is regarded by the industry as the best product in the market. Modesta Glass Coatings features a family of products with amazing chemical protection to wheels, paint, and paint protection film. This ensures that your vehicle is well-protected against bird droppings, bugs, and other environmental hazards. Additionally, Modesta Glass Coatings are the most hydrophobic coatings in the market, and create a cleaning effect the enhances the cleanliness of your vehicle and facilitates washing.',
    },
    {
        image: 'mmd-feature-img-3.jpg',
        title: 'Paint Correction',
        tabId: 'Paint-Correction',
        content: 'Paint correction shows off the beauty of your vehicle to the world. Our deep and extensive paint polishing process tailors to your vehicle, resulting in exceptional color, gloss, and reflectivity. We remove any paint defects from the surface of your vehicle that have resulted from bird bombs, water spots, mark scratches, and more. With our team’s process, we ensure your vehicle is enhanced and ready to be showcased at its best.',
    },
]
const galleryList = [
    {
        image: 'gallery-img1.jpg',
    },
    {
        image: 'gallery-img2.jpg',
    },
    {
        image: 'gallery-img3.jpg',
    },
    {
        image: 'gallery-img4.jpg',
    },
    {
        image: 'gallery-img5.jpg',
    },
    {
        image: 'gallery-img6.jpg',
    },
    {
        image: 'gallery-img7.jpg',
    },
    {
        image: 'gallery-img8.jpg',
    },
]
const MarkMotorsDetailing = () => {
    const handleScrollToTab = (label) => {
        const item = mmdList.find((itm) => itm.tabId === label);
        if (item) {
            const el = document.getElementById(item.tabId);
            if (el) {
                el.scrollIntoView({ behavior: 'smooth' });
            }
        }
    };
    const handleMoveOnRequestForm = () => {
        const section = document.getElementById("RequestForm");
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
        }
    }
    return (
        <>
            <section className='common-banner-wrap mob-h-240 position-relative'>
                <img src={getImages('mark-customs.webp')} />
                <div className='cb-pos'>
                    <div className='xl-title text-uppercase mb-3 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.5s">Mark Motors Detailing</div>
                    <div className='lg-title font-2-5em text-uppercase text-center fw-400 wow fadeInUp' data-wow-duration="0.7s" data-wow-delay="0.8s">Boerne’s Premium Detail Shop</div>
                    <div className='mt-5 text-center wow fadeInUp' data-wow-duration="1s" data-wow-delay="1s">
                        <button type='button' className='btn-theme w-330 text-gray'
                            onClick={handleMoveOnRequestForm}
                        >Request Appointment</button>
                    </div>
                </div>
            </section>
            <section className='common-wrap py-5 mark-wrap'>
                <div className='container'>
                    <div className='text-center wow fadeInUp mb-5' data-wow-duration="1s" data-wow-delay="0.5s">
                        <ul className="mark-tab-list d-inline-flex align-items-center">
                            <li>
                                <button className="mtl-btn active">Detailing Home</button>
                            </li>
                            <li>
                                <button className="mtl-btn" onClick={() => handleScrollToTab('Premium-Detailing')}>Premium Detailing</button>
                            </li>
                            <li>
                                <button className="mtl-btn" onClick={() => handleScrollToTab('Modesta-Glass-Coatings')}>Modesta Glass Coatings</button>
                            </li>
                            <li>
                                <button className="mtl-btn" onClick={() => handleScrollToTab('Paint-Correction')}>Paint Correction</button>
                            </li>
                        </ul>
                    </div>
                    <div className='tab-content'>
                        <div className='md-title text-uppercase mb-4 font-2-2em wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.7s">Excellence In Detailing Through an Extensive Deep Cleaning and Protection Process</div>
                        <p className='fw-300 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.9s">At Mark Motors Detailing, our team cares about your vehicle as if it were our own. From premium detailing, Modesta Glass Coatings, and paint correction, our exceptional team of experts is here to serve you. We take great pride in every vehicle that comes into our shop, and will work meticulously on it until it feels as if you just left the dealership for for the first time.</p>
                        {mmdList.map((item, index) =>
                            <div id={item.tabId}>
                                <div className='d-flex mmd-flex wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.5s" key={index}>
                                    <div className='mmd-image'>
                                        <img src={getImages(item.image)} />
                                    </div>
                                    <div className='mmd-content'>
                                        <div className='md-title font-1-5em text-uppercase mb-2'>{item.title}</div>
                                        <div className='mmd-mnh'>
                                            <p>{item.content}</p>
                                        </div>
                                        <div className="mt-4 text-end">
                                            <button type="button" className="get-started-btn w-330 text-black" onClick={handleMoveOnRequestForm}>Request Appointment</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>
            <MarkBrand />
            <section className='mmd-team-wrap'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-6 text-center wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.5s">
                            <div className='mm-team-image mb-5'>
                                <img src={getImages('Mike_Gottlieb.png')} />
                            </div>
                            <div className='md-title text-uppercase mb-3'>Mike Gottlieb</div>
                            <div className='xs-title font-1-2em fw-400 opacity-0-7'>Team Lead</div>
                        </div>
                        <div className='col-md-6 text-center wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.7s">
                            <div className='mm-team-image mb-5'>
                                <img src={getImages('Brian_Yim.png')} />
                            </div>
                            <div className='md-title text-uppercase mb-3'>Brian Yim</div>
                            <div className='xs-title font-1-2em fw-400 opacity-0-7'>Senior Team Member</div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='gallery-wrap'>
                <div className='container'>
                    <div className='md-title text-uppercase mb-5 font-2-2em wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.3s">Gallery</div>
                    <div className='row gallery-block'>
                        {galleryList.map((item, index) => (
                            <div className='col-md-3 col-6 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.5s" key={index}>
                                <div className='gl-box'>
                                    <img src={getImages(item.image)} alt='Gallery' />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <section className='schedule-appointment-wrap' id='RequestForm'>
                <div className='container mxw-980'>
                    <div className='sm-title text-start text-uppercase font-1-5em mb-5 fw-500wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.5s">Schedule your Appointment or Request Information</div>
                    <ScheduleAppointment />
                </div>
            </section>
        </>
    )
}

export default MarkMotorsDetailing